import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {LoadingIndicator} from '../components/LoadingIndicator';
import {RequestItem, SupportItems} from '../components/SupportItem';
import {Flow, FlowFetchResponse} from '../_services/Flow';

type SupportProps = {};

export const Support: React.FunctionComponent<SupportProps> = (): JSX.Element => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [openRequests, setOpenRequests] = useState<RequestItem[]>([]);
    const [recentRequests, setRecentRequests] = useState<RequestItem[]>([]);

    useEffect(() => {
        setIsLoading(true);

        Flow.getInstance().getSupportRequests()
            .then((response: FlowFetchResponse) => {
                if (response.ok) {
                    setOpenRequests(response.json.open);
                    setRecentRequests(response.json.closed);
                } else {
                    throw Error(response?.json?.message || 'Error fetching open requests');
                }
            })
            .catch((error: any) => {
                console.log(error);
            })
            .finally(() => {
                setIsLoading(false);
            })

    }, []);

    return (
        <div>
            {isLoading && <LoadingIndicator/>}
            <h1 className={'abb-header'}>Help &amp; Support</h1>



            <div className="text-center mb-4">
                <Link to="/new/93"
                      className="btn btn-lg btn-outline-secondary"
                >
                    <i className="far fa-plus-circle mr-1"/>
                    New Support Request
                </Link>
            </div>

            <div className="row mb-2">
                <div className="col-xs-6 col-sm-5 offset-sm-1 col-md-5 offset-md-1 col-lg-5 offset-lg-1 mb-2">
                    <div className="card">
                        <div className="card-header">
                            My Open Requests
                        </div>
                        <div className="card-body p-0">
                            {isLoading ?
                                <></>
                                :
                                openRequests?.length > 0 ?
                                    <SupportItems requestItems={openRequests}/>
                                    :
                                    <p className="card-text text-center p-4">
                                        <em>No Open Requests</em>
                                    </p>
                            }
                        </div>
                    </div>
                </div>
                <div className="col-xs-6 col-sm-5 col-md-5 col-lg-5">
                    <div className="card">
                        <div className="card-header">
                            Recently Closed Requests
                        </div>
                        <div className="card-body p-0">
                            {isLoading ?
                                <></>
                                :
                                recentRequests?.length > 0 ?
                                    <SupportItems requestItems={recentRequests}/>
                                    :
                                    <p className="card-text text-center p-4">
                                        <em>No Requests in the past 6 months</em>
                                    </p>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};